import React, {useEffect, useRef, useState} from "react";
import SimpleTable from "../../../common/tables/SimpleTable";
import {useDispatch, useSelector} from "react-redux";
import {getRusDateHourString} from "../../../../utils/dateUtils";
import {LinkCopyPopup} from "../../../common/linkCopyPopup/LinkCopyPopup";
import RosLineEditPopover from "./RosLineEditPopover";
import {loadRosLines} from "../../../../actions/rosLinesActions";
import {RosLineModal} from "./RosLineModal";
import {executeSync} from "../../../../utils/syncUtils";
import useResizeObserver from "../../../../hooks/useResizeObserver";
import {isDesktop} from "../../../../utils/displayUtils";
import {sort} from "../../../../utils/sortUtils";
import {ASC, DESC} from "../../../../utils/constants";

export default function RosMetricsContent() {
    const rosLines = useSelector(state => state.rosLinesReducer.rosLines);

    const dispatch = useDispatch();
    const childRef = useRef();
    const childRef2 = useRef();
    const [tableData, setTableData] = useState([]);
    const [sortableColumn, setSortableColumn] = useState(null);
    const [sortableDirection, setSortableDirection] = useState(null);
    const [selectedRosLine, setSelectedRosLine] = useState(null);
    const [needToOpenLastItemInModal, setNeedToOpenLastItemInModal] = useState(false);


    useEffect(() => {
        dispatch(loadRosLines());
    }, []);

    useEffect(() => {
        if (!rosLines) {
            return;
        }
        const tableData = [...rosLines];
        if (sortableDirection && sortableColumn) {
            const directionNumb = sortableDirection === DESC ? -1 : sortableDirection === ASC ? 1 : 0;
            const sortedTableData = sort(tableData, sortableColumn, directionNumb);
            setTableData(sortedTableData);
        } else {
            setTableData(tableData);
        }
    }, [rosLines, sortableColumn, sortableDirection]);

    useEffect(() => {
        if (!rosLines || !needToOpenLastItemInModal) {
            return;
        }
        const sortedByDate = [...rosLines];
        executeSync(() => sortedByDate.sort((a, b) => b.createdAt - a.createdAt)).then(() => openModal(sortedByDate[0]));
        setNeedToOpenLastItemInModal(false);
    }, [needToOpenLastItemInModal, rosLines])

    const setSorting = (column, direction) => {
        setSortableColumn(column);
        setSortableDirection(direction);
    };

    const openModal = (rosLine) => {
        setSelectedRosLine(rosLine);
        childRef2.current.openModal();
    };

    const tableColumns = () => {
        return [
            {
                name: "Line ID",
                key: "lineId",
                getBodyCellValue: item => <RosLineTableCell item={item} value={item["lineId"]}/>,
                headerCellStyle: {maxWidth: "10%", width: "10%"},
                bodyCellStyle: {textAlign: "center"},
            },
            {
                name: "Название",
                key: "name",
                getBodyCellValue: item => <RosLineTableCell item={item} value={item["name"]}/>,
                headerCellStyle: {maxWidth: "20%", width: "15%"},
                bodyCellStyle: {textAlign: "center"},
            },
            {
                name: "Дата добавления",
                key: "createdAt",
                getBodyCellValue: item => <RosLineTableCell item={item} value={getRusDateHourString(new Date(item["createdAt"]))}/>,
                headerCellStyle: {maxWidth: "15%", width: "15%"},
                bodyCellStyle: {textAlign: "center"},
            },
            {
                name: "Точки",
                key: "line",
                getBodyCellValue: item => <div onClick={() => openModal(item)}><RosLineTableCell item={item} value={<div style={{whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis"}}>{item.line?.join(", ")}</div>}/></div>,
                headerCellStyle: {maxWidth: "40%"},
                bodyCellStyle: {textAlign: "center", maxWidth: "200px", width: "200px", cursor: "pointer"},
                isSortingDisabled: true,
            },
            {
                name: <RosLineEditPopover
                    button={<i className="ti ti-plus td-save"/>}
                    tooltip="Добавить"
                    popoverLocation='right'
                    label=""
                    afterSaveCallback={() => setNeedToOpenLastItemInModal(true)}
                />,
                key: "actions",
                getBodyCellValue: (item) =>
                    <div style={{display: "flex", flexDirection: "row-reverse"}}>
                       <span className="link" onClick={() =>
                           childRef.current.handleClickCopy(item?.line.join(", "))}>
                        <i className="ti ti-files" style={{cursor: "pointer", fontSize: "18px"}} title="Копировать точки"/></span>
                    </div>,
                headerCellStyle: {maxWidth: "10%", width: "5%", textAlign: "right"},
                bodyCellStyle: {textAlign: "right", width: "50px"},
                isSortingDisabled: true,
            },
        ]
    };

    const height = useResizeObserver(document.getElementById("scrollable")).height - (isDesktop() ? 0 : 50);

    return <div className="responsive-block statistic_table_wrapper" id="fullWidth" onScroll={() =>{}} style={{minHeight: '75vh', height: (height + "px")}}>
        <SimpleTable tableClassName="table table-bordered nowrap statistic_table sticky-header sticky-action sticky-footer userselecttext"
                     columns={tableColumns()} data={tableData} bodyRowKey="id" isSortable sortableColumn={sortableColumn} sortableDirection={sortableDirection} onSort={setSorting}/>
        <LinkCopyPopup ref={childRef} message="Точки скопированы"/>
        <RosLineModal ref={childRef2} rosLineData={selectedRosLine}/>
    </div>
}

const RosLineTableCell = ({item, value}) => {
    return item?.isLast ? value : <span style={{opacity: '0.65'}} >{value}</span>
};